module.exports = __webpack_public_path__ + "img/result_inauguration.0f5d7488.png";